<script>
import { defineComponent } from 'vue';
import moment from 'moment';
import UUIDHelper from '@/helpers/uuid.js';

export default defineComponent({
    name: 'quoteToOrderModal',
    setup() {},
    data() {
        return {
            openModal: false,
            selectedLocation: null,
            step: 1,
            renderComponent: true,
            active: {},
            items: [],
            removingIndex: null,
            orderNote: "",
            po: "",
            fax: "",
            faxAttn: "",
            shipVia: "",
            carrier: "",
            reset: null,
            q: null,
            timer: null,
            slideRatio: {},
            options: [
                'Bestway', '1 Day', '2 Day', 'Will Call'
            ],
            right2: {},

            // order processing
            order: {},
            isSubmitting: false
        }
    },
    methods: {
        cancelForm() {
            this.step=1;
            this.removingIndex = null;
            this.orderNote = "";
            this.selectedLocation = null;
            this.items = [];
            this.active={};
            this.po = "";
            this.fax = "";
            this.faxAttn = "";
            this.carrier = "";
            this.shipVia = "";
            this.$store.commit('customer/setQuoteToOrder', null);

        },
        removeItem({reset}) {
            this.finalize(reset)
        },
        onAction(details) {
            this.reset = details
        },
        onSlide (item) {
            this.removingIndex = item;   
        },
        finalize(reset) {
            this.timer = setTimeout(() => {
                this.removedItems[this.removingIndex.itemNumber] = this.removingIndex;
                //this.items = this.items.filter(x => x.itemNumber != this.removingIndex.itemNumber);
                //reset();
                //this.$store.dispatch('message/sendMessage', {message: `${this.removingIndex.itemNumber} Removed`, type: 'info', position: 'bottom', icon: 'delete'}, {root:true});
                this.removingIndex = null;
            }, 100)
        },
        resetItem() {
            this.reset();
        },
        selectLocation(idx) {
            this.selectedLocation = idx;
            this.resetSelected();
            this.active[idx] = true;
        },
        resetSelected() {
            for (const [key, value] of Object.entries(this.active)) {
                this.active[key] = false;
            }
        },
        processOrder() {
            this.isSubmitting = true;

            //? reset form
            this.resetOrder();
            this.order.accessToken = this.accessToken;
            this.order.cartGUID = "[MOBILE-QUOTES]" + UUIDHelper.GenerateUUID();
            //? order reference
            this.order.requestDate = moment().format("YYYY-MM-DD");
            this.order.comments = this.orderNote;
            this.order.shipVia = this.shipVia;
            this.order.carrier = this.carrier;
            //? billing information
            this.order.purchaseOrderNumber = this.po;
            this.order.jobNumber = "";
            this.order.buyer = this.user.userName;
            this.order.email = this.user.userEmail;
            //? ship to
            this.order.shipTo.name = this.shipTos.shiptos[this.selectedLocation].name;
            this.order.shipTo.attention = this.shipTos.shiptos[this.selectedLocation].attention;
            this.order.shipTo.address1 = this.shipTos.shiptos[this.selectedLocation].address1;
            this.order.shipTo.address2 = this.shipTos.shiptos[this.selectedLocation].address2;
            this.order.shipTo.city = this.shipTos.shiptos[this.selectedLocation].city;
            this.order.shipTo.state = this.shipTos.shiptos[this.selectedLocation].state;
            this.order.shipTo.zip = this.shipTos.shiptos[this.selectedLocation].zip;
            this.order.shipTo.country = this.shipTos.shiptos[this.selectedLocation].country;
            this.order.shipTo.phoneNumber = this.shipTos.shiptos[this.selectedLocation].phonNumber;
            //? order confirmation
            this.order.fax = this.fax;
            this.order.faxAttention = this.faxAttn;

            //? build array of catalog items  
            this.order.items = [];
            this.items.forEach((i, idx) => {

                if (this.right2[idx]) {
                    // reset item object
                    var item = {}
                    item.itemNumber = i.itemNumber;
                    item.quantityOrdered = parseInt(i.quantityOrdered);
                    item.rackPackFlag = i.quantityUnitOfMeasure=='FT' || i.quantityUnitOfMeasure=='MFT' ? true : false;
                    item.comments = "";
                    item.price = parseFloat(i.price);

                    this.order.items.push(item)
                }


            }) 

            // process order
            this.$store.dispatch('customer/processOrder', [this.accessToken, this.order]);
            this.cancelForm();

        },
        resetOrder() {
            this.order = {};
            this.order.accessToken = ""
            this.order.purchaseOrderNumber = ""
            this.order.requestDate = ""
            this.order.comments = ""
            this.order.shipVia = ""
            this.order.carrier = ""
            this.order.jobNumber = ""
            this.order.buyer = ""
            this.order.email = ""
            this.order.fax = ""
            this.order.faxAttention = ""
            this.order.shipTo = {}
            this.order.shipTo.name = ""
            this.order.shipTo.attention = "" 
            this.order.shipTo.address1 = ""
            this.order.shipTo.address2 = ""
            this.order.shipTo.city = ""
            this.order.shipTo.state = ""
            this.order.shipTo.zip = ""
            this.order.shipTo.country = ""
            this.order.shipTo.phoneNumber = ""
            this.order.items = []
        }, 
    },
    computed: {
        quoteToOrder() {
            return this.$store.getters['customer/quoteToOrder'];
        },
        shipTos() {
            return this.$store.getters['customer/shipTos'];
        },
        accessToken() {
            return this.$store.getters['auth/accessToken'];
        },
        user() {
            return this.$store.getters['auth/user'];
        },
        isProcessingOrder() {
            return this.$store.getters['customer/isProcessingOrder'];
        },
        minItemsSelected() {
            var v = false;
            for (const [key, value] of Object.entries(this.right2)) {
                value==true? v=true : null;
            }
            return v
        }
    },
    watch: {
        quoteToOrder() {
            if (this.quoteToOrder != null) {
                this.openModal = true;
                this.quoteToOrder.items.forEach(i => {
                    this.items.push(i);
                });
                this.items.forEach((i, idx) => {
                    this.right2[idx] = true;
                })
            } else {
                this.openModal = false;
                this.items=[];
            }
        },
        shipTos() {
            this.shipTos.shiptos.forEach((i, idx) => {
            this.active[idx] = false;
        })
        }
    },
    mounted() {

    }
})
</script>

<template>
    <q-dialog v-model="openModal" persistent full-height full-width>

      <q-card :dark=true>

        <q-card-section>
          <div class="text-h6">Place Order</div>
        </q-card-section>

        <q-card-section>
          <div class="q-pa-none">
            <q-stepper v-model="step" vertical animated dark>
                
                <!-- STEP 1: SELECT SHIP-TO LOCATION -->
                <q-step :dense=true :name="1" active-color="cyan-7" done-color="positive" title="Ship-to Address" icon="local_shipping" :done="step > 1" >
                    <q-scroll-area :dark=true style="height: 35vh; width: 60vw !important">
                    <q-list dark separator dense v-if="shipTos!=null">
                        <span v-for="(loc, idx) in shipTos.shiptos" :key="idx">
                            <q-item clickable v-ripple @click="selectLocation(idx)" :active="active[idx]" active-class="test">
                                <q-item-section>
                                <q-item-label>{{loc.name}}</q-item-label>
                                <q-item-label class="text-grey-6" caption lines="1">{{loc.address1}}</q-item-label>
                                <q-item-label class="text-grey-6" caption lines="1">{{loc.address2}}</q-item-label>
                                <q-item-label class="text-grey-6" caption lines="1">{{loc.city}}, {{loc.state}} {{loc.zip}}</q-item-label>
                                </q-item-section>
                            </q-item>
                            <q-separator color="grey-5" :dark=true  />
                        </span>
                    </q-list>
                    </q-scroll-area>

                    <q-stepper-navigation  class="q-pt-md q-pb-none">
                        <q-btn @click="step = 2" :outline=true color="cyan-7" label="Continue" :disabled="selectedLocation==null" />
                    </q-stepper-navigation>
                </q-step>

                <!-- STEP 2: SELECT ITEMS TO ORDER -->
                <q-step :name="2" active-color="cyan-7" done-color="positive" title="Items to Order" icon="checklist" :done="step > 2">
                    <q-scroll-area :dark=true style="height: 37vh; width: 60vw !important">
                        <q-list bordered separator class="q-pa-none" :dense=true>
                            <span v-for="(item, idx) in items" :key="idx">
                                <q-item clickable v-ripple bordered  :dense=true>
                                    <q-item-section avatar top>
                                        <q-checkbox v-model="right2[idx]" unchecked-icon="swipe_right" color="cyan-7" keep-color />
                                    </q-item-section>
                                    <q-item-section color="dark" style="max-width: 70vw">
                                            <q-item-label>{{item.itemNumber}}</q-item-label>
                                            <q-item-label class="text-grey-1" caption lines="1">{{item.description}}</q-item-label>
                                            <q-item-label v-if="item.quantityOrdered" class="text-grey-1" caption lines="1">{{parseInt(item.quantityOrdered)}} {{item.quantityUnitOfMeasure}}</q-item-label>
                                            <q-item-label v-if="item.quantityShipped" class="text-grey-1" caption lines="1">{{parseInt(item.quantityShipped)}} {{item.quantityUnitOfMeasure}}</q-item-label>
                                    </q-item-section>
                                </q-item>
                                <q-separator color="grey-5" :dark=true  /> 
                            </span>
                        </q-list>
                    </q-scroll-area>

                    <q-stepper-navigation>
                    <q-btn @click="step = 3" :outline=true color="cyan-7" label="Continue" :disabled="!minItemsSelected" />
                    <q-btn flat @click="step = 1" color="grey-7" label="Back" class="q-ml-sm" />
                    </q-stepper-navigation>
                </q-step>

                <!-- STEP 3: ORDER INFO -->
                <q-step :name="3" active-color="cyan-7" done-color="positive" title="Order Info" icon="domain">
                    <q-input color="cyan-7" square :dark=true :dense=true label="Purchase Order" v-model="po" filled />
                    <q-select class="q-mt-xs" filled color="cyan-7" v-model="shipVia" :dark=true :dense=true :options="options" label="Ship VIA" />
                    <q-input class="q-mt-xs" square color="cyan-7" :dark=true :dense=true label="Carrier (optional)" v-model="carrier" filled />
                    <q-input class="q-mt-xs" square color="cyan-7" :dark=true :dense=true label="Fax # (optional)" v-model="fax" filled />
                    <q-input class="q-mt-xs" square color="cyan-7" :dark=true :dense=true label="Fax Attn (optional)"  v-model="faxAttn" filled />

                    <q-stepper-navigation>
                        <q-btn @click="step = 4" :outline=true color="cyan-7" label="Continue" :disabled="po.length==0||shipVia.length==0" />
                        <q-btn flat @click="step = 2" color="grey-7" label="Back" class="q-ml-sm" />
                    </q-stepper-navigation>
                </q-step>

                <!-- STEP 4: ADD A NOTE -->
                <q-step :name="4" active-color="cyan-7" done-color="positive" title="Add Note" caption="Optional" icon="edit_note">
                    <q-input color="cyan-7" :dark=true v-model="orderNote" filled type="textarea" />

                            <q-stepper-navigation>
                    <q-btn @click="step = 5" :outline=true color="cyan-7" label="Continue" />
                    <q-btn flat @click="step = 3" color="grey-7" label="Back" class="q-ml-sm" />
                    </q-stepper-navigation>
                </q-step>

                <!-- STEP 5: SUBMIT ORDER -->
                <q-step :name="5" active-color="positive" title="Submit Order" icon="shopping_cart">
                    Your order will be submitted for processing by the WCW fulfillment team

                    <q-stepper-navigation>
                        <q-btn color="positive" :outline=true label="Submit" @click="processOrder()" :loading="isProcessingOrder">
                            <template v-slot:loading>
                                <q-spinner-hourglass class="on-center" />
                            </template>
                        </q-btn>
                        <q-btn flat @click="step = 3" color="grey-7" label="Back" class="q-ml-sm" />
                    </q-stepper-navigation>
                </q-step>
            </q-stepper>
        </div>
        </q-card-section>
      
      <q-card-section>
        <q-btn flat color="warning" label="Cancel" @click="cancelForm()"></q-btn>
      </q-card-section>
      </q-card>
    </q-dialog>
</template>

<style scoped>
.test{
    background-color: lightcyan
}
</style>